
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

type FeatureProps = {
  title: string;
  description: string;
};

type HowItWorksCardProps = {
  title?: string;
  description?: string;
  features: FeatureProps[];
};

const HowItWorksCard = ({
  title = "How It Works",
  description = "Our analysis uses multiple detection techniques",
  features
}: HowItWorksCardProps) => {
  return (
    <Card className="mt-6">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {features.map((feature, index) => (
          <div key={index}>
            <h3 className="font-medium">{feature.title}</h3>
            <p className="text-sm text-muted-foreground">{feature.description}</p>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default HowItWorksCard;
